//#region ../event-service/dist/service.types-B-7T0reA.js
var e = {
	SalesChannelStatusChanged: "SalesChannelStatusChanged",
	ProductCreated: "ProductCreated",
	ProductUpdated: "ProductUpdated",
	OrderAlreadyDiscovered: "OrderAlreadyDiscovered",
	OrderCreated: "OrderCreated",
	OrderDeleted: "OrderDeleted",
	OrderRulesEvaluated: "OrderRulesEvaluated",
	OrderUpdated: "OrderUpdated",
	Printed: "Printed",
	PrintErrored: "PrintErrored"
}, t = {
	Account: "account",
	Shop: "shop",
	Order: "ORDER",
	Product: "PRODUCT",
	Print: "PRINT"
}, n = {
	Event: "Event",
	Order: "Order",
	Printing: "Printing",
	Product: "Product"
};
//#endregion
export { n, t as r, e as t };
